/* eslint-disable react/no-string-refs */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import { Row, Col, Collapse, Well } from "react-bootstrap";
import Formsy from "formsy-react";
import { DateRangePicker } from "react-dates";
import { IoPerson, IoList } from "react-icons/io5";
import { orderBy, isEmpty } from "lodash";
import moment from "moment";

import * as callActions from "../../actions/callActions";
import * as modalActions from "../../actions/modalActions";
import * as customerActions from "../../actions/customerActions";
import * as contractActions from "../../actions/contractActions";
import * as userActions from "../../actions/userActions";
import * as projectActions from "../../actions/projectActions";
import * as departmentActions from "../../actions/departmentActions";
import * as supportTicketActions from "../../actions/supportTicketActions";
import * as codeActions from "../../actions/codeActions";

import DropdownSearch, { DropdownSearchSelect } from "./DropdownSearch";
import ContractTypeSelect from "./ContractTypeSelect";
import Checkbox from "../expense/ExpenseApprovalCheckbox";
import CustomToggle from "./Toggle";

class FiltersComponent extends Component {
  constructor(props) {
    super(props);
    this.state = { tickets: [] };
  }

  componentDidMount = async () => {
    const { codes, departments, projects, customers, actions, fields, users } =
      this.props;
    if (isEmpty(codes)) actions.loadCodes();
    if (
      (fields.includes("Department") ||
        fields.includes("Assigned Department") ||
        fields.includes("DPS") ||
        fields.includes("PES")) &&
      isEmpty(departments)
    ) {
      actions.loadDepartments();
    }
    if (
      (fields.includes("Customer") ||
        fields.includes("Assigned Customer") ||
        fields.includes("PES")) &&
      isEmpty(customers)
    )
      actions.loadCustomers();
    if (fields.includes("Project") && isEmpty(projects)) actions.loadProjects();
    if (
      (fields.includes("Salesperson") || fields.includes("Employee")) &&
      isEmpty(users)
    ) {
      actions.loadUsers();
    }
  };

  // to make orderBy case Insensitive you must call the toLowerCase() function on it like below
  generateCodeOptions = (entity, field) => {
    const codeOptions = this.props.codes
      .filter((codes) => codes.entity === entity && codes.field === field)
      .map((code) => ({
        value: code._id,
        label: code.label,
        order: code.order
      }));
    return orderBy(
      codeOptions,
      [(option) => option.label.toLowerCase()],
      "order"
    );
  };

  generateUserOptions = () => {
    const userOptions = this.props.users
      // .filter(
      //   user =>
      //     user.department.id == auth.user.department.id
      // )
      .map((user) => ({
        value: user._id,
        label: user.full_name
      }));

    return orderBy(userOptions, [(option) => option.label.toLowerCase()]);
  };

  generateSalespersonOptions = () => {
    const userOptions = this.props.users
      .filter((user) => user.roles?.find((role) => role.name === "Salesperson"))
      .map((user) => ({
        value: user._id,
        label: user.full_name
      }));

    return orderBy(userOptions, [(option) => option.label.toLowerCase()]);
  };

  generateCustomerOptions = () => {
    const customerOptions = this.props.customers.map((customer) => ({
      value: customer._id,
      label: customer.name
    }));
    return orderBy(customerOptions, [(option) => option.label.toLowerCase()]);
  };

  generateProjectOptions = () => {
    const projectOptions = this.props.projects.map((project) => ({
      value: project._id,
      label: `${project.name} - ${project.project_number}`
    }));
    return orderBy(projectOptions, [(option) => option.label.toLowerCase()]);
  };

  generateDepartmentOptions = () => {
    const departmentOptions = this.props.departments.map((department) => ({
      value: department._id,
      label: department.description
    }));
    return orderBy(departmentOptions, [(option) => option.label.toLowerCase()]);
  };

  generateContractOptions = () => {
    const contractOptions = this.props.contracts.map((contract) => ({
      value: contract._id,
      label: contract.name
    }));
    return orderBy(contractOptions, [(option) => option.label.toLowerCase()]);
  };

  generateWorkplaceOptions = () => {
    const workplaceOptions = this.props.codes
      .filter((code) => code.entity === "Call" && code.field === "workplace")
      .map((code) => ({ value: code._id, label: code.label }));
    return orderBy(workplaceOptions, [(option) => option.label.toLowerCase()]);
  };

  generatePriorityOptions = () => {
    const priorityOptions = this.props.codes
      .filter((code) => code.entity === "Call" && code.field === "priority")
      .map((code) => ({ value: code._id, label: code.label }));
    return orderBy(priorityOptions, [(option) => option.label.toLowerCase()]);
  };

  render() {
    const { filters, fields, codes, loading } = this.props;
    const status = {
      approved: codes?.find(
        (c) => c.label === "Approved" && c.entity === "Expenses"
      ),
      completed: codes?.find(
        (c) => c.label === "Completed" && c.entity === "Expenses"
      ),
      open: codes?.find(
        (c) => c.label === "Open" && c.entity === "Support Ticket"
      ),
      resolved: codes?.find(
        (c) => c.label === "Resolved" && c.entity === "Support Ticket"
      ),
      submitted: codes?.find(
        (c) => c.label === "Submitted" && c.entity === "Expenses"
      )
    };
    return (
      <Collapse in={this.props.open} className="filter-container">
        <div>
          <Well>
            <Formsy ref="form" className="vertical form">
              <div className="fields">
                {fields.includes("Status") && (
                  <DropdownSearch
                    isMulti
                    placeholder="Status"
                    name="stage"
                    onChange={this.props.onChangeFilters}
                    value={filters.stage}
                    data={[...this.generateCodeOptions("Call", "status")]}
                  />
                )}
                {fields.includes("Project Status") && (
                  <DropdownSearch
                    isMulti
                    placeholder="Status"
                    name="project_status"
                    onChange={this.props.onChangeFilters}
                    value={filters.project_status}
                    data={[...this.generateCodeOptions("Project", "status")]}
                  />
                )}
                {fields.includes("Ticket Status") && (
                  <DropdownSearch
                    isMulti
                    placeholder="Status"
                    name="request_status"
                    disabled={loading}
                    onChange={this.props.onChangeFilters}
                    value={filters.request_status}
                    data={[
                      ...this.generateCodeOptions("Support Ticket", "status")
                    ]}
                  />
                )}
                {fields.includes("Customer") && (
                  <DropdownSearch
                    isMulti
                    name="customer"
                    placeholder="Customer"
                    onChange={this.props.onChangeFilters}
                    value={filters.customer}
                    data={[...this.generateCustomerOptions()]}
                  />
                )}
                {fields.includes("Project") && (
                  <DropdownSearch
                    isMulti
                    name="project"
                    placeholder="Project"
                    onChange={this.props.onChangeFilters}
                    value={filters.project}
                    data={[...this.generateProjectOptions()]}
                  />
                )}
                {fields.includes("Multi Project") && (
                  <DropdownSearch
                    isMulti
                    name="project"
                    placeholder="Project"
                    onChange={this.props.onChangeFilters}
                    value={filters.project}
                    data={this.props.filteredProjects.map((project) => ({
                      value: project._id,
                      label: `${project.name} - ${project.project_number}`
                    }))}
                  />
                )}
                {fields.includes("Department") && (
                  <DropdownSearch
                    isMulti
                    placeholder="Department"
                    name="department"
                    onChange={this.props.onChangeFilters}
                    value={filters.department}
                    data={[...this.generateDepartmentOptions()]}
                  />
                )}
                {fields.includes("is_assigned") && (
                  <DropdownSearch
                    placeholder="Is Assigned"
                    name="is_assigned"
                    onChange={this.props.onChangeFilters}
                    value={filters.is_assigned}
                    data={[
                      { value: true, label: "Assigned" },
                      {
                        value: false,
                        label: "Unassigned"
                      }
                    ]}
                  />
                )}
                {fields.includes("Assigned To") && (
                  <DropdownSearch
                    isMulti
                    placeholder="Assigned To"
                    name="assigned_to"
                    onChange={this.props.onChangeFilters}
                    value={filters.assigned_to}
                    data={[...this.generateUserOptions()]}
                  />
                )}
                {fields.includes("Assigned Department") && (
                  <DropdownSearch
                    isMulti
                    placeholder="Assigned Department"
                    name="assigned_department"
                    onChange={this.props.onChangeFilters}
                    value={filters.assigned_department}
                    data={[...this.generateDepartmentOptions()]}
                  />
                )}
                {fields.includes("Multi Assigned To") && (
                  <DropdownSearch
                    isMulti
                    placeholder="Assigned Employee"
                    name="multi_assigned_to"
                    onChange={this.props.onChangeFilters}
                    value={filters.multi_assigned_to}
                    data={this.props.filteredUsers.map((user) => ({
                      value: user._id,
                      label: user.full_name
                    }))}
                  />
                )}
                {fields.includes("Assigned Customer") && (
                  <DropdownSearch
                    isMulti
                    name="customer"
                    placeholder="Assigned Customer"
                    onChange={this.props.onChangeFilters}
                    value={filters.customer}
                    data={[...this.generateCustomerOptions()]}
                  />
                )}
                {fields.includes("Employee") && (
                  <DropdownSearch
                    isMulti
                    placeholder="Employee"
                    name="employee"
                    onChange={this.props.onChangeFilters}
                    value={filters.employee}
                    data={[...this.generateUserOptions()]}
                  />
                )}
                {fields.includes("Project Manager") && (
                  <DropdownSearch
                    isMulti
                    placeholder="Project Manager"
                    name="project_manager"
                    onChange={this.props.onChangeFilters}
                    value={filters.project_manager}
                    data={[...this.generateUserOptions()]}
                  />
                )}
                {fields.includes("Call Type") && (
                  <DropdownSearch
                    isMulti
                    placeholder="Call Type"
                    name="call_type"
                    onChange={this.props.onChangeFilters}
                    value={filters.call_type}
                    disabled={this.props.callTypeDisabled}
                    data={[...this.generateCodeOptions("Call", "type")]}
                  />
                )}
                {fields.includes("Date") && (
                  <DateRangePicker
                    startDate={
                      filters.arrival_date ? moment(filters.arrival_date) : null
                    }
                    startDateId="startDate"
                    endDate={
                      filters.completed_date
                        ? moment(filters.completed_date)
                        : null
                    }
                    endDateId="endDate"
                    onDatesChange={({ startDate, endDate }) => {
                      this.props.onChangeDate(startDate, endDate);
                    }}
                    isOutsideRange={() => false}
                    focusedInput={this.props.focusedInput}
                    onFocusChange={this.props.onFocusChange}
                  />
                )}
                {fields.includes("expense_date") && (
                  <DateRangePicker
                    startDate={
                      filters.startDate ? moment(filters.startDate) : null
                    }
                    startDateId="startDate"
                    endDate={filters.endDate ? moment(filters.endDate) : null}
                    endDateId="endDate"
                    onDatesChange={({ startDate, endDate }) => {
                      this.props.onChangeDate(startDate, endDate);
                    }}
                    isOutsideRange={() => false}
                    focusedInput={this.props.focusedInput}
                    onFocusChange={this.props.onFocusChange}
                  />
                )}
                {fields.includes("expenseStatus") && (
                  <DropdownSearch
                    isExpenseStatus
                    placeholder="Show Completed"
                    name="status"
                    onChange={this.props.onChangeFilters}
                    value={filters.status[0]}
                    data={[
                      { value: status?.completed?.id, label: "Completed" },
                      {
                        value: status?.approved?.id,
                        label: "Not Yet Completed"
                      }
                    ]}
                  />
                )}
                {fields.includes("Project Category") && (
                  <DropdownSearch
                    isMulti
                    placeholder="Category"
                    name="category"
                    onChange={this.props.onChangeFilters}
                    value={filters.category}
                    data={[
                      ...this.generateCodeOptions("Project", "project_category")
                    ]}
                  />
                )}
                {fields.includes("Contract Status") && (
                  <DropdownSearch
                    isMulti
                    placeholder="Status"
                    name="contract_status"
                    onChange={this.props.onChangeFilters}
                    value={filters.contract_status}
                    data={[...this.generateCodeOptions("Contract", "status")]}
                  />
                )}
                {fields.includes("Workplace") && (
                  <DropdownSearch
                    isMulti
                    placeholder="Workplace"
                    name="workplace"
                    onChange={this.props.onChangeFilters}
                    value={filters.workplace}
                    data={[...this.generateWorkplaceOptions()]}
                  />
                )}
                {fields.includes("Priority") && (
                  <DropdownSearch
                    isMulti
                    placeholder="Priority"
                    name="priority"
                    onChange={this.props.onChangeFilters}
                    value={filters.priority}
                    data={[...this.generatePriorityOptions()]}
                  />
                )}
                {fields.includes("Summary Level") && (
                  <DropdownSearch
                    placeholder="Summary Level"
                    name="summaryLevel"
                    onChange={this.props.onChangeFilters}
                    value={filters.summaryLevel}
                    data={[
                      { label: "Dept Summary", value: 1 },
                      { label: "Dept/Cust Summary", value: 2 },
                      { label: "Dept/Cust/Proj/Emp Summary", value: 3 }
                    ]}
                  />
                )}
                {fields.includes("Approved") && (
                  <Col sm={12}>
                    <Checkbox
                      className="checkbox expense"
                      style={{ margin: "0 0", display: "inline" }}
                      onClickCheck={(e) =>
                        this.props.onChangeFilters(
                          "ApprovedStatus",
                          {
                            value: status?.approved?._id
                          },
                          e.target.checked
                        )
                      }
                      disabled={
                        !!filters.status?.find(
                          (s) => s.value === status?.completed?._id
                        )
                      }
                      checked={
                        !filters.status?.find(
                          (s) => s.value === status?.submitted?._id
                        )
                      }
                    />
                    <div style={{ display: "inline" }}>Approved</div>
                  </Col>
                )}
                {fields.includes("Billed") && (
                  <Col sm={12}>
                    <Checkbox
                      className="checkbox expense"
                      style={{ margin: "0 0" }}
                      onClickCheck={(e) =>
                        this.props.onChangeFilters(
                          "to_customer_complete",
                          e.target.checked
                        )
                      }
                      checked={filters.to_customer_complete}
                    />
                    <div style={{ display: "inline" }}>Billed to Customer</div>
                  </Col>
                )}
                {fields.includes("Reimbursed") && (
                  <Col sm={12}>
                    <Checkbox
                      className="checkbox expense"
                      style={{ margin: "0 0" }}
                      onClickCheck={(e) =>
                        this.props.onChangeFilters(
                          "to_employee_complete",
                          e.target.checked
                        )
                      }
                      checked={filters.to_employee_complete}
                    />
                    <div style={{ display: "inline" }}>Reimbursed Employee</div>
                  </Col>
                )}
                {fields.includes("GroupByEmployee") && (
                  <Col sm={12}>
                    <CustomToggle
                      name="grouped_by_employee"
                      label="Group By Employee"
                      onChange={(e) =>
                        this.props.onChangeFilters(
                          "grouped_by_employee",
                          e.target.checked
                        )
                      }
                      value={filters.grouped_by_employee}
                      checkedIcon={<IoList />}
                      uncheckedIcon={<IoPerson />}
                    />
                  </Col>
                )}
                {fields.includes("Contract") && (
                  <DropdownSearch
                    name="contract"
                    placeholder="Contract"
                    onChange={this.props.onChangeFilters}
                    value={filters.contract.value}
                    data={[...this.generateContractOptions()]}
                  />
                )}
                {fields.includes("Month") && (
                  <DropdownSearchSelect
                    isSearchable={false}
                    placeholder="Month"
                    name="month"
                    onChange={this.props.onChangeFilters}
                    value={filters.month}
                    data={filters.months}
                  />
                )}
                {fields.includes("Year") && (
                  <DropdownSearchSelect
                    isSearchable={false}
                    placeholder="Year"
                    name="year"
                    onChange={this.props.onChangeFilters}
                    value={filters.year}
                    data={filters.years}
                  />
                )}
                {fields.includes("DPS") && (
                  <React.Fragment>
                    <div>
                      <h4 style={{ fontWeight: 700 }}>Department</h4>
                      <DropdownSearchSelect
                        placeholder="Department"
                        name="department"
                        onChange={this.props.onChangeFilters}
                        value={filters.department}
                        data={[...this.generateDepartmentOptions()]}
                      />
                    </div>
                    <div>
                      <h4 style={{ fontWeight: 700 }}>Week Of</h4>
                      <DropdownSearchSelect
                        isSearchable={false}
                        placeholder="Week"
                        name="week"
                        onChange={this.props.onChangeFilters}
                        value={filters.week}
                        data={filters.weeks}
                      />
                    </div>
                  </React.Fragment>
                )}
                {fields.includes("PES") && (
                  <React.Fragment>
                    <div>
                      <h4 style={{ fontWeight: 700 }}>Department</h4>
                      <DropdownSearchSelect
                        isClearable
                        placeholder="Department"
                        name="department"
                        onChange={this.props.onChangeFilters}
                        value={filters.department}
                        data={[...this.generateDepartmentOptions()]}
                      />
                    </div>
                    <div>
                      <h4 style={{ fontWeight: 700 }}>Customer*</h4>
                      <DropdownSearchSelect
                        name="customer"
                        onChange={this.props.onChangeFilters}
                        value={filters.customer}
                        data={[...this.generateCustomerOptions()]}
                      />
                    </div>
                    <div>
                      <h4 style={{ fontWeight: 700 }}>Project*</h4>
                      <DropdownSearchSelect
                        name="project"
                        onChange={this.props.onChangeFilters}
                        value={filters.project}
                        data={[...this.generateProjectOptions()]}
                      />
                    </div>
                    <div>
                      <h4 style={{ fontWeight: 700 }}>Date Range</h4>
                      <DateRangePicker
                        startDate={
                          filters.arrival_date
                            ? moment(filters.arrival_date)
                            : null
                        }
                        startDateId="startDate"
                        endDate={
                          filters.completed_date
                            ? moment(filters.completed_date)
                            : null
                        }
                        endDateId="endDate"
                        onDatesChange={({ startDate, endDate }) => {
                          this.props.onChangeDate(startDate, endDate);
                        }}
                        isOutsideRange={() => false}
                        focusedInput={this.props.focusedInput}
                        onFocusChange={this.props.onFocusChange}
                      />
                    </div>
                  </React.Fragment>
                )}
                {fields.includes("Contract Type") && (
                  <ContractTypeSelect
                    value={filters.contract_type}
                    isMulti
                    onChange={(options) =>
                      this.props.onChangeFilters("contract_type", options)
                    }
                  />
                )}
                {fields.includes("Salesperson") && (
                  <DropdownSearch
                    isMulti
                    placeholder="Salesperson"
                    name="salesperson"
                    onChange={this.props.onChangeFilters}
                    value={filters.salesperson}
                    data={[...this.generateSalespersonOptions()]}
                  />
                )}
                {fields.includes("Location") && (
                  <DropdownSearch
                    placeholder="Location"
                    name="location"
                    onChange={this.props.onChangeFilters}
                    value={filters.location}
                    data={[
                      { label: "EU", value: "EU" },
                      { label: "Other", value: "other" }
                    ]}
                  />
                )}
                {fields.includes("ResponseDue") && (
                  <DropdownSearch
                    placeholder="Response Due"
                    name="response_due"
                    onChange={this.props.onChangeFilters}
                    value={filters.response_due?.value}
                    data={[
                      { value: "past", label: "Past Due" },
                      {
                        value: "soon",
                        label: "Due Soon"
                      }
                    ]}
                  />
                )}
              </div>
              {this.props.showResetButton && (
                <Row className="mb-0">
                  <Col md={12}>
                    <button
                      className="btn btn-warning"
                      type="button"
                      onClick={this.props.onReset}
                    >
                      Reset
                    </button>
                  </Col>
                </Row>
              )}
              {this.props.showFetchButton && (
                <Row className="mb-0">
                  <Col md={12}>
                    <button
                      className="btn btn-primary"
                      type="button"
                      disabled={loading}
                      onClick={this.props.onFetch}
                    >
                      Fetch Data
                    </button>
                  </Col>
                </Row>
              )}
            </Formsy>
          </Well>
        </div>
      </Collapse>
    );
  }
}

FiltersComponent.propTypes = {
  codes: PropTypes.array,
  actions: PropTypes.object,
  users: PropTypes.array,
  customers: PropTypes.array,
  projects: PropTypes.array,
  departments: PropTypes.array,
  onChangeFilters: PropTypes.func,
  open: PropTypes.bool,
  filters: PropTypes.object,
  fields: PropTypes.array,
  filteredProjects: PropTypes.array,
  filteredUsers: PropTypes.array,
  onChangeDate: PropTypes.func,
  focusedInput: PropTypes.node,
  onFocusChange: PropTypes.func,
  onReset: PropTypes.func,
  callTypeDisabled: PropTypes.bool,
  showResetButton: PropTypes.bool,
  loading: PropTypes.bool,
  contracts: PropTypes.array,
  showFetchButton: PropTypes.bool,
  onFetch: PropTypes.func
};

FiltersComponent.defaultProps = {
  callTypeDisabled: false,
  showResetButton: true,
  loading: false,
  contracts: [],
  showFetchButton: false,
  onFetch: () => null
};

function mapStatesToProps(state) {
  return {
    state: state.reducers,
    customers: state.reducers.customers,
    users: state.reducers.users,
    projects: state.reducers.projects,
    departments: state.reducers.departments,
    chargetypes: state.reducers.chargetypes,
    codes: state.reducers.codes,
    contracts: state.reducers.contracts
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...modalActions,
        ...callActions,
        ...codeActions,
        ...contractActions,
        ...userActions,
        ...departmentActions,
        ...supportTicketActions,
        ...projectActions,
        ...customerActions
      },
      dispatch
    )
  };
}

export default connect(mapStatesToProps, mapDispatchToProps)(FiltersComponent);
